import { req } from 'react-reqq-lite';

import { formatGetQueryParams } from 'modules/common/utils';
import { withAclReq } from 'modules/partial/hooks';
import { toastError } from 'modules/common/toast';
import { toastSuccess } from 'modules/common';

import * as c from './constants';
import * as t from './transformers';

export const getDiscounts = ({ params } = {}, cb) => {
  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: '/v1/settings/group/DISCOUNTS',
        },
        MERCHANT: {
          url: '/v1/settings/group/DISCOUNTS',
        },
        BRANCH: {
          url: '/v1/settings/group/DISCOUNTS',
        },
      }),
      {
        key: c.GET_DISCOUNTS,
        params: formatGetQueryParams(params, true),
        transform: ({ data, meta }) => ({
          data: data?.map(t.transformGetDiscounts),
          pagination: meta?.pagination,
        }),
        onSuccess: (res) => {
          if (typeof cb === 'function') cb(res);
        },
      }
    )
  );
};

export const getSelectedDiscount = ({ params } = {}, cb) => {
  req.get({
    key: c.GET_SELECTED_DISCOUNT,
    params,
    transform: t.transformGetDiscounts,
    onSuccess: (res) => {
      if (typeof cb === 'function') cb(res);
    },
  });
};

export const getSettings = ({ params } = {}, cb) => {
  req.get({
    url: '',
    key: c.GET_SETTINGS,
    params,
    transform: ({ data }) => t.transformGetSettings(data),
    onSuccess: (res) => {
      if (typeof cb === 'function') cb(res);
    },
  });
};

export const postQuickCheckout = ({ params } = {}, cb) => {
  req.get({
    key: c.POST_QUICK_CHECKOUT,
    params,
    onSuccess: (res) => {
      if (typeof cb === 'function') cb(res);
    },
  });
};

export const putQuickCheckout = ({ params, payload } = {}, cb) => {
  req.put({
    url: '/v1/me/pos/order/quick-checkout',
    key: c.PUT_QUICK_CHECKOUT,
    params,
    payload: t.transformPutQuickCheckout(payload),
    onSuccess: (res) => {
      if (typeof cb === 'function') cb(res);
    },
    onError: ({ response }) => {
      setTimeout(() => {
        toastError(response?.message);
      }, 50);
    },
  });
};

export const checkoutOrder = ({ payload, qrKey } = {}, cb) => {
  req.post({
    url: `/v1/customer/pos/${qrKey}/quick-checkout`,
    key: c.CHECKOUT_ORDER,
    payload: t.transformGenerateDraft(payload),
    onSuccess: () => {
      toastSuccess('Order was received.');
      cb();
    },
  });
};

export const addProduct = ({ payload, order_uuid } = {}, cb) => {
  req.post({
    url: `/v1/me/pos/order/${order_uuid}`,
    key: c.ADD_PRODUCT,
    payload: t.transformGenerateDraft(payload),
    onSuccess: () => {
      toastSuccess('Order added successfully.');
      cb();
    },
  });
};
